import { Component, EventEmitter, OnInit } from '@angular/core';
import { EToken } from "../../shared/model/etoken";
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-etoken-terceiros',
  templateUrl: './etoken-terceiros.component.html',
  styleUrls: ['./etoken-terceiros.component.css']
})
export class EtokenTerceirosComponent implements OnInit {
  public dataSource: MatTableDataSource<EToken>
  public eventoNovoEToken: EventEmitter<number> = new EventEmitter<number>();
  public eventoExcluirEToken: EventEmitter<any> = new EventEmitter<any>();

  displayedColumns: string[] = ['acao', 'emailTerceiro', 'tipoLabel', 'dataExibicao', 'status'];

  constructor() { }

  ngOnInit() {
  }

  onCreateNew() {
    this.eventoNovoEToken.emit(this.dataSource.data.length);
  }

  onDelete(token) {
    let currentEToken: EToken = token;
    this.eventoExcluirEToken.emit(currentEToken);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
